import React from 'react';
import { IconSearch, IconBuildingAdd } from './Icons';

/**
 * Two different situations reach this component and they need different words:
 * a search that matched nothing (recoverable - clear the query) and a registry
 * with no providers at all (nothing to recover, so point at onboarding).
 * The previous copy told everyone to "browse all providers" without offering
 * any way to do it.
 */
const EmptyState = ({ query = '', onClearSearch }) => {
  if (query) {
    return (
      <div className="ds-state ds-state--empty">
        <span className="ds-state__icon-wrap">
          <IconSearch className="ds-state__icon" aria-hidden />
        </span>
        <h3 className="ds-state__title">No providers match “{query}”</h3>
        <p className="ds-state__text">
          Check the spelling, or try a broader term such as an industry or product group.
        </p>
        {onClearSearch && (
          <button type="button" className="btn btn-secondary ds-state__action" onClick={onClearSearch}>
            Show all providers
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="ds-state ds-state--empty">
      <span className="ds-state__icon-wrap">
        <IconBuildingAdd className="ds-state__icon" aria-hidden />
      </span>
      <h3 className="ds-state__title">No data providers yet</h3>
      <p className="ds-state__text">
        Once a company registers, its Asset Administration Shells become discoverable here.
      </p>
    </div>
  );
};

export default EmptyState;
